module.exports = __webpack_public_path__ + "img/Portfolio.59d92a0f.svg";